import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    authExternal: 'N',
    transactionId: '',
    userInfo: {},
    aplCatl: '',
    callBackParam: '',
};

export const permissions = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
